import {
  printReceiptQR,
  printReceiptBT,
  printReceiptSerial,
  printStornoReceiptSerial,
  printStornoReceiptBT,
  printStornoReceiptQR,
  payInBT,
  payInSerial,
  payInQR,
  payOutBT,
  payOutSerial,
  payOutQR,
  openDayBT,
  openDaySerial,
  openDayQR,
  closeDayBT,
  closeDaySerial,
  closeDayQR
} from './printCommands'
import {
  fiscatAeeSale,
  fiscatAeeDayOpen,
  fiscatAeeDayClose,
  fiscatAeePayIn,
  fiscatAeePayOut,
  fiscatAeeStorno
} from './fiscatV4Model'

const fiscatIPalmDriver = {
  printReceipt: {
    FiscatIPalmQR: async (fiscalReceipt, printSlip, deviceParams, sendMessageToWebView) => {
      return await printReceiptQR(fiscalReceipt, printSlip, fiscatAeeSale, deviceParams, sendMessageToWebView)
    },
    FiscatIPalmBT: async (fiscalReceipt, printSlip, deviceParams, sendMessageToWebView) => {
      return await printReceiptBT(fiscalReceipt, printSlip, fiscatAeeSale, deviceParams, sendMessageToWebView)
    },
    FiscatIPalmSerial: async (fiscalReceipt, printSlip, deviceParams, sendMessageToWebView) => {
      return await printReceiptSerial(fiscalReceipt, printSlip, fiscatAeeSale, deviceParams, sendMessageToWebView)
    }
  },
  printStornoReceipt: {
    FiscatIPalmQR: async (fiscalReceipt, deviceParams, sendMessageToWebView) => {
      return await printStornoReceiptQR(fiscalReceipt, fiscatAeeStorno, deviceParams, sendMessageToWebView)
    },
    FiscatIPalmBT: async (fiscalReceipt, deviceParams, sendMessageToWebView) => {
      return await printStornoReceiptBT(fiscalReceipt, fiscatAeeStorno, deviceParams, sendMessageToWebView)
    },
    FiscatIPalmSerial: async (fiscalReceipt, deviceParams, sendMessageToWebView) => {
      return await printStornoReceiptSerial(fiscalReceipt, fiscatAeeStorno, deviceParams, sendMessageToWebView)
    }
  },
  openDay: {
    FiscatIPalmQR: async (amount, reserved, deviceParams, sendMessageToWebView) => {
      return await openDayQR("LOCA", amount, fiscatAeeDayOpen, deviceParams, sendMessageToWebView)
    },
    FiscatIPalmBT: async (amount, reserved, deviceParams, sendMessageToWebView) => {
      return await openDayBT("LOCA", amount, fiscatAeeDayOpen, deviceParams, sendMessageToWebView)
    },
    FiscatIPalmSerial: async (amount, reserved, deviceParams, sendMessageToWebView) => {
      return await openDaySerial("LOCA", amount, fiscatAeeDayOpen, deviceParams, sendMessageToWebView)
    }
  },
  closeDay: {
    FiscatIPalmQR: async (deviceParams, sendMessageToWebView) => {
      return await closeDayQR(fiscatAeeDayClose, deviceParams, sendMessageToWebView)
    },
    FiscatIPalmBT: async (deviceParams, sendMessageToWebView) => {
      return await closeDayBT(fiscatAeeDayClose, deviceParams, sendMessageToWebView)
    },
    FiscatIPalmSerial: async (deviceParams, sendMessageToWebView) => {
      return await closeDaySerial(fiscatAeeDayClose, deviceParams, sendMessageToWebView)
    }
  },
  payIn: {
    FiscatIPalmQR: async (reason, amount, type, deviceParams, sendMessageToWebView, info) => {
      return await payInQR(reason, amount, type, fiscatAeePayIn, deviceParams, sendMessageToWebView, info)
    },
    FiscatIPalmBT: async (reason, amount, type, deviceParams, sendMessageToWebView, info) => {
      return await payInBT(reason, amount, type, fiscatAeePayIn, deviceParams, sendMessageToWebView, info)
    },
    FiscatIPalmSerial: async (reason, amount, type, deviceParams, sendMessageToWebView, info) => {
      return await payInSerial(reason, amount, type, fiscatAeePayIn, deviceParams, sendMessageToWebView, info)
    }
  },
  payOut: {
    FiscatIPalmQR: async (reason, amount, type, deviceParams, sendMessageToWebView, info) => {
      return await payOutQR(reason, amount, type, fiscatAeePayOut, deviceParams, sendMessageToWebView, info)
    },
    FiscatIPalmBT: async (reason, amount, type, deviceParams, sendMessageToWebView, info) => {
      return await payOutBT(reason, amount, type, fiscatAeePayOut, deviceParams, sendMessageToWebView, info)
    },
    FiscatIPalmSerial: async (reason, amount, type, deviceParams, sendMessageToWebView, info) => {
      return await payOutSerial(reason, amount, type, fiscatAeePayOut, deviceParams, sendMessageToWebView, info)
    }
  }
}

export {
  fiscatIPalmDriver
}